module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D08-clean-1e5409cb6d75b257aec534571bd169f7.png";